import type { components } from "../../api/schema";
import { apiClient } from "../../lib/apiClient";
import { ApiRequestError } from "../../lib/errors";
import type { MarkerOutput } from "../markerAuthoringDraft";
import { wholeTranscriptLocator } from "./labelInspectorDraft";

type Marker = components["schemas"]["MarkerResponse"];
type MarkerCreate = components["schemas"]["MarkerCreate"];

export async function createHumanOnlyMarker({
  agentId,
  output,
  displayName,
}: {
  agentId: string | undefined;
  output: MarkerOutput;
  displayName: string;
}): Promise<Marker> {
  if (agentId == null) {
    throw new Error("Choose an agent before creating a Marker.");
  }
  const title = displayName.trim();
  if (title.length === 0) {
    throw new Error("Display name is required.");
  }
  const body: MarkerCreate = {
    agent_id: agentId,
    assertion: null,
    output_spec: null,
    display_name: title,
    evaluator: null,
    locator: wholeTranscriptLocator,
    output,
    description: null,
    review_policy: "never",
    review_sample_rate: null,
    spec: null,
  };
  const { data, error } = await apiClient.POST("/v1/markers", { body });
  if (error) {
    throw new ApiRequestError(error);
  }
  return data;
}
